module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.564a682c.ttf";